import * as z from 'zod'

export const promoSearchSchema = z.object({
  report: z
    .boolean()
    .optional()
    .refine((val) => val),
  deal: z.string().optional(),
  deal_url: z.string().optional(),
})

export type PromoSearchModel = z.infer<typeof promoSearchSchema>

export const defaultPromoSearch: PromoSearchModel = {
  report: undefined,
  deal: undefined,
  deal_url: undefined,
}
